// Role helpers — single source of truth for role checks.
// A user can be a Mobilitier via primary `role` OR via `secondary_role` (dual role).

export const isMobilitier = (user) =>
  !!user && (user.role === 'mobilitier' || user.secondary_role === 'mobilitier');

export const isRenter = (user) =>
  !!user && (user.role === 'user' || user.secondary_role === 'user');

export const isAdmin = (user) => !!user && user.role === 'admin';
